import { createSelector } from '@reduxjs/toolkit'
import { sortCheckpointableEntities } from '../../../helpers/sortCheckpointableEntities'
import {
  getOverduePhaseItemsIds,
  getOverdueAssignmentsIds,
} from '../../getters/entities/taskIds'
import { NormalizedTask } from '../types'
import { selectNormalizedTasks } from './normalizedTasks'

const selectOverdueAssignmentIds = createSelector(
  [getOverdueAssignmentsIds],
  (overdueAssignmentIds) => overdueAssignmentIds || []
)

const selectOverduePhaseItemIds = createSelector(
  [getOverduePhaseItemsIds],
  (overduePhaseItemIds) => overduePhaseItemIds || []
)

export const selectOverdueTasks = createSelector(
  [
    selectNormalizedTasks,
    selectOverdueAssignmentIds,
    selectOverduePhaseItemIds,
  ],
  (normalizedTasks, overdueAssignmentIds, overduePhaseItemIds) => {
    const phaseItems = overduePhaseItemIds.map((id) =>
      normalizedTasks.find(
        (task) => task.id === id && task.entityType === 'phase_item'
      )
    )

    const assignments = overdueAssignmentIds.map((id) =>
      normalizedTasks.find(
        (approval) => approval.id === id && approval.entityType === 'assignment'
      )
    )

    return sortCheckpointableEntities(
      [...phaseItems, ...assignments].filter(
        (task): task is NormalizedTask => task !== undefined
      )
    )
  }
)
